import { Injectable, ViewChild } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  CustomModalService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { CustomFacade } from '@piqet-angular/data';
import { GridService } from 'libs/shared/src/lib/service/grid.service';
import { cloneDeep } from 'lodash';
import { AgGridComponent } from 'libs/shared/src/lib/ag-grid/ag-grid.component';
import { NumericCellEditor } from 'libs/ui/src/lib/numeri-cell-editor/numeric-cell-editor.component';
import { getRolesAndPermission } from 'libs/shared/src/lib/service/helper.service';
import { Subject, take } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class CustomConversionDataGridService {
  editConversion = new Subject<[any, any, any, any]>();
  editConversionObservable$ = this.editConversion.asObservable();

  deleteConversion = new Subject<[any, any, any]>();
  deleteConversionObservable$ = this.deleteConversion.asObservable();

  copyConversion = new Subject<[any, any, any]>();
  copyConversionObservable$ = this.copyConversion.asObservable();

  inlineEditing = new Subject<[any, any]>();
  inlineEditingObservable$ = this.inlineEditing.asObservable();

  customConversionPayload: any;
  @ViewChild(AgGridComponent)
  gridComponent!: AgGridComponent;
  conversionProcessList!: [];
  conversionProcessItems!: [];
  event: any;
  Access: any;
  editData = new Subject<[any, any, any, any]>();
  customConversionObservable$ = this.editData.asObservable();
  currentRoute: string = '';
  constructor(
    private customFacade: CustomFacade,
    private accessService: AccessPermissionService,
    private swalService: SwalService,
    private toaster: ToastrService
  ) {}

  accessAllPermission(type: string) {
    const access =
      this.isAccess(type, 'edit') || this.isAccess(type, 'delete') || this.isAccess(type, 'create');
    return access;
  }

  getCustomConversionDataColumn(pathName?: any): ColDef[] {
    this.currentRoute = pathName;
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'ProcessName',
      headerName: 'My custom conversion',
      field: 'processName',
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        const checkAccess = this.isAccess(pathName, 'edit') || this.isAccess(pathName, 'view');
        if (checkAccess) {
          cellElement.title = dblclickTooltipDef;
          cellElement.style.textDecoration = 'underline';
        }
        cellElement.addEventListener('dblclick', () => {
          checkAccess &&
            this.editConversion.next([
              params.data,
              params.data.id,
              'Review custom conversion',
              pathName,
            ]);
        });
        return cellElement;
      },
      wrapText: true,
      autoHeight: true,
      resizable: false,
      editable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Description',
      headerName: 'Description',
      field: 'comment',
      suppressColumnsToolPanel: true,
      cellClass: ['outerGridEdit'],
      valueSetter: (params: any) => {
        const newValInt = params.newValue;
        const valueChanged = params.data.comment !== newValInt;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data.comment =
            typeof params.oldValue == 'number' ? parseInt(newValInt) : newValInt;
        }
        const inlineObject = {
          entityId: 'id',
          entityIdValue: params.data['id'],
          entityColumnName: params.colDef.field,
          entityColumnValue: params.data[params.colDef.field],
        };
        this.inlineEditing.next([inlineObject, 'CustomConversion']);
        return valueChanged;
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: this.isAccess(pathName, 'edit'),
      cellRenderer: (params: any) => {
        const extraClass =
          pathName === 'adminCustomConversion'
            ? 'editable-icon-padding-admin-custom-menu'
            : 'editable-icon-padding';
        return `<span class="editable-icon ${extraClass}" title="${params.value}">${params.value}<i class="fa fa-pencil icon-opacity" aria-hidden="true"></i></span>`;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Cost per package (USD)',
      headerName: 'Cost per package (USD)',
      field: 'packageCostSum',
      width: 468,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agNumberColumnFilter',
      editable: false,
    });

    {
      pathName == 'adminCustomConversion' &&
        colDef.push({
          ...defaultColumn,
          colId: 'OrganizationName',
          headerName: 'Organization name',
          field: 'organizationName',
          maxWidth: grid_widths_map.sm_column_xl,
          minWidth: grid_widths_map.sm_column_sm,
          cellClass: 'my-permission-cursor-pointer',
          width: 468,
          wrapText: true,
          autoHeight: true,
          lockVisible: true,
          resizable: false,
          filter: 'agTextColumnFilter',
          editable: false,
        });
    }

    colDef.push({
      ...defaultColumn,
      colId: 'OwnerName',
      headerName: 'Owner',
      field: 'ownerName',
      width: 468,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    this.accessAllPermission(pathName) &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        resizable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          showEdit: this.isAccess(pathName, 'edit'),
          showCopy: this.isAccess(pathName, 'create'),
          showDelete: this.isAccess(pathName, 'delete'),
          value: 'customConversion',
          deleteData: (data: any, pathName: any) => {
            if (pathName == 'adminCustomConversion') {
              this.deleteCustomConfirmation(
                data,
                '/AdminCustomConversion/DeleteConvertion',
                pathName
              );
            } else {
              this.deleteCustomConfirmation(data, '/CustomConversion/DeleteConvertion', pathName);
            }
          },
          copyData: (data: any, pathName: any) => {
            if (pathName == 'adminCustomConversion') {
              this.copyConversion.next([
                data,
                '/AdminCustomConversion/SaveCloneCustomConvertion',
                pathName,
              ]);
            } else {
              this.copyConversion.next([
                data,
                '/CustomConversion/SaveCloneCustomConvertion',
                pathName,
              ]);
            }
          },
          editData: (data: any, pathName: any) => {
            this.editConversion.next([data, data.id, 'Review custom conversion', pathName]);
          },
          copyDataEditRendarar: (data: any) => {
            return false;
          },
        },
        lockVisible: true,
        lockPosition: right,
      });

    return colDef;
  }

  isAccess = (pathName: any, type: 'view' | 'edit' | 'create' | 'delete') => {
    return pathName.includes('admin')
      ? this.accessService.hasModulePermission(
          rolesModuleName.AdministratorConversion,
          mainModuleName.projectManagementModule,
          type
        )
      : this.accessService.hasModulePermission(
          rolesModuleName.customConversion,
          mainModuleName.customModule,
          type
        );
  };

  innedGridActionAccess(fromEdit: boolean): boolean {
    return (
      (!fromEdit && this.isAccess(this.currentRoute, 'create')) ||
      (fromEdit && !this.isAccess(this.currentRoute, 'view')) ||
      (fromEdit && this.isAccess(this.currentRoute, 'edit'))
    );
  }

  getNewProcessColumns(fromEdit: boolean = false): ColDef[] {
    let newValue: any;
    let energyId: any;
    let enableEditing: any;
    let resetData: any;
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'process',
      headerName: 'Process',
      field: 'processName',
      cellEditor: 'GridCellRendererComponent',
      maxWidth: grid_widths_map.sm_column_xl,
      minWidth: grid_widths_map.sm_column_xl,
      cellEditorParams: {
        from: 'conversionProcess',
        editData: (data: any) => {
          newValue = data.processName;
          energyId = data.energyId;
        },
      },
      cellRenderer: (params: any) => {
        return `<div class="truncated-text" title="${params.value}">${
          params.value ? params.value : ''
        }</div>`;
      },
      valueSetter: (params: any) => {
        const newVal = !!newValue ? newValue : 'Select process';
        const valueChanged =
          !!newValue && !resetData ? params.data[params.colDef.field] !== newVal : false;
        params.data = { ...params.data };
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
          params.data['energyId'] = energyId;
          params.data['enableEditing'] = enableEditing;
          const colId = params.colDef.field;
          const nodeId = params.data.id;

          this.customFacade.checkUpdateActionFire$.pipe(take(1)).subscribe((flag: boolean) => {
            flag &&
              this.customFacade.updateConversionProcessActions(
                params.data,
                'edit',
                null,
                nodeId,
                colId
              );
          });
          newValue = '';
          energyId = '';
        }
        return valueChanged;
      },
      valueGetter: params => {
        return params.data.processName;
      },
      editable: true,
      sortable: false,
      wrapText: true,
      resizable: false,
      lockPosition: true,
      lockVisible: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'amount',
      headerName: 'Amount *',
      field: 'amount',
      suppressColumnsToolPanel: true,
      wrapText: true,
      lockVisible: true,
      lockPosition: true,
      resizable: false,
      sortable: false,
      editable: true,
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'amount') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      cellEditorParams: {
        from: 'conversion-amount',
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = !resetData && params.data[params.colDef.field] !== newVal;
        params.data = { ...params.data };
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
          params.data['enableEditing'] = enableEditing;
          const colId = params.colDef.field;
          const nodeId = params.data.id;
          this.customFacade.checkUpdateActionFire$.pipe(take(1)).subscribe((flag: boolean) => {
            flag &&
              this.customFacade.updateConversionProcessActions(
                params.data,
                'edit',
                null,
                nodeId,
                colId
              );
          });
          return valueChanged;
        } else {
          return false;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'comment',
      headerName: 'Comment',
      field: 'comment',
      wrapText: true,
      lockVisible: false,
      lockPosition: true,
      resizable: false,
      sortable: false,
      editable: true,
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        params.data = { ...params.data };
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
          const colId = params.colDef.colId;
          params.data['enableEditing'] = enableEditing;
          const nodeId = params.data.id;
          this.customFacade.checkUpdateActionFire$.pipe(take(1)).subscribe((flag: boolean) => {
            flag &&
              this.customFacade.updateConversionProcessActions(
                params.data,
                'edit',
                null,
                nodeId,
                colId
              );
          });
          return valueChanged;
        } else {
          return false;
        }
      },
    });

    this.innedGridActionAccess(fromEdit) &&
      colDef.push({
        ...defaultColumn,
        colId: 'actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'inlineActionButtonComponent',
        cellRendererParams: {
          showInlineEdit: true,
          showInlineCopy: true,
          showInlineDelete: true,
          from: 'customConversion',
          copyDataEditRendarar: (data: any) => {
            this.customFacade.copyConversionProcessActions(data, 'copy');
          },
          copyData: (data: any) => {
            return false;
          },
          inlineEditData: (data: any) => {
            enableEditing = data.data.enableEditing;
            resetData = data.data.resetData;
          },
          deleteInlineGrid: (data: any) => {
            this.alertConfirmation(data);
          },
        },
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });
    return colDef;
  }

  alertConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.customFacade.deleteConversionProcessAction(data, 'delete');
      }
    });
  }

  deleteCustomConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteConversion.next([data, customType, pathName]);
      }
    });
  }

  isEmpty(val: any) {
    if (val !== undefined || val !== null || val !== '') {
      val = val.trim();
    }
    return val === undefined || val === null || val === '';
  }
}
